var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorTriangleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.33347C16.3568 2.33347 16.6866 2.52361 16.8654 2.83243L31.5321 28.1658C31.7112 28.4751 31.7115 28.8566 31.533 29.1663C31.3544 29.476 31.0241 29.6668 30.6666 29.6668H1.33331C0.975834 29.6668 0.645543 29.476 0.466989 29.1663C0.288434 28.8566 0.288777 28.4751 0.467887 28.1658L15.1346 2.83243C15.3133 2.52361 15.6431 2.33347 16 2.33347ZM3.06776 27.6668H28.9322L16 5.32933L3.06776 27.6668Z",
    fill: "#EE7200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.3335C16.5523 22.3335 17 22.7812 17 23.3335V24.0001C17 24.5524 16.5523 25.0001 16 25.0001C15.4477 25.0001 15 24.5524 15 24.0001V23.3335C15 22.7812 15.4477 22.3335 16 22.3335Z",
    fill: "#EE7200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 11.6671C16.5514 11.6667 16.9995 12.114 17 12.6663L17.0055 19.3326C17.006 19.8849 16.5586 20.333 16.0063 20.3335C15.4541 20.3339 15.006 19.8866 15.0055 19.3343L15 12.668C14.9995 12.1157 15.4469 11.6676 15.9991 11.6671Z",
    fill: "#EE7200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleOutline);
export default __webpack_public_path__ + "static/media/error-triangle-outline.d5e7f078.svg";
export { ForwardRef as ReactComponent };